import { createSlice } from '@reduxjs/toolkit';
import { REHYDRATE } from 'redux-persist';
import resources from '../../resources';
import { type RehydrateAction } from '../../types/store/actions/RehydrateAction';
import { type AuthState } from '../../types/store/states/AuthState';
import { getToken, logout, updateSignature } from '../thunks/auth';

const initialState: AuthState = {
  loggedIn: false,
  token: null,
  facilityUser: null,
  redirectUrl: '/',
} as AuthState;

const auth = createSlice({
  reducerPath: undefined,
  selectors: undefined,
  reducers: {},
  name: 'auth',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getToken.pending, (state) => {
        resources.setToken(null);
        state.loggedIn = false;
        state.token = null;
        state.facilityUser = null;
      })
      .addCase(getToken.fulfilled, (state, action) => {
        resources.setToken(action.payload);

        state.loggedIn = true;
        state.token = { ...action.payload, client: null };
        state.facilityUser = action.payload.data.facilityUser ?? null;
      })
      .addCase(getToken.rejected, (state) => {
        resources.setToken(null);
        state.loggedIn = false;
        state.token = null;
        state.facilityUser = null;
      })
      .addCase(logout.fulfilled, (state, action) => {
        resources.setToken(null);
        state.loggedIn = false;
        state.token = null;
        state.facilityUser = null;
        state.redirectUrl = action.payload;
      })
      .addCase(logout.rejected, () => {
        console.error('Failed to unauthenticate with the node server');
      })
      .addCase(updateSignature.fulfilled, (state, action) => {
        if (state.facilityUser) {
          state.facilityUser.inmateRequestSignature = action.meta.arg;
        }
      })
      .addCase(updateSignature.rejected, () => {
        console.error('Failed to update signature');
      })
      .addCase(REHYDRATE, (_, action: RehydrateAction) => {
        if (
          action &&
          action.payload &&
          action.payload.auth &&
          action.payload.auth.token
        ) {
          resources.setToken(action.payload.auth.token);
        }
      });
  },
});

export default auth.reducer;
